var $2656ce930519213b$exports = {};
$2656ce930519213b$exports = {
    "decrease": (args)=>`Decrease ${args.fieldLabel}`,
    "increase": (args)=>`Increase ${args.fieldLabel}`,
    "numberField": `Number field`
};


export {$2656ce930519213b$exports as default};
//# sourceMappingURL=en-US.mjs.map
